export const defaultComponentConfig = {
    successUrl: undefined,
    title: 'Are you sure?',
    copy: 'If you wish to sign out please confirm by hitting the button below!',
    goBackButtonText: 'Go Back',
    signOutButtonText: 'Sign Out',
};
